import Vue from 'vue'
import VueI18n from 'vue-i18n'
// EN
import en from './locales/en/en.json'
import enMenu from './locales/en/enMenu.json'
import enHomePage from './locales/en/enHomePage.json'
import enSeatsPage from './locales/en/enSeatsPage.json'
import enRecovery from './locales/en/enRecovery.json'
import enActivityLogsPage from './locales/en/enActivityLogsPage.json'
import enSettingsPage from './locales/en/enSettingsPage.json'
import enForms from './locales/en/enForms.json'

// ES
import es from '@/boot/i18n/locales/es/es.json'
import esMenu from '@/boot/i18n/locales/es/esMenu.json'
import esHomePage from '@/boot/i18n/locales/es/esHomePage.json'
import esSeatsPage from '@/boot/i18n/locales/es/esSeatsPage.json'
import esRecovery from './locales/es/esRecovery.json'
import esActivityLogsPage from './locales/es/esActivityLogsPage.json'
import esSettingsPage from './locales/es/esSettingsPage.json'
import esForms from './locales/es/esForms.json'

// JP
import ja from './locales/ja/ja.json'
import jaMenu from './locales/ja/jaMenu.json'
import jaHomePage from './locales/ja/jaHomePage.json'
import jaSeatsPage from './locales/ja/jaSeatsPage.json'
import jaRecovery from './locales/ja/jaRecovery.json'
import jaActivityLogsPage from './locales/ja/jaActivityLogsPage.json'
import jaSettingsPage from './locales/ja/jaSettingsPage.json'
import jaForms from './locales/ja/jaForms.json'


Vue.use(VueI18n)


const messages = {
  en: {
    common: en,
    menu: enMenu,
    home: enHomePage,
    seats: enSeatsPage,
    recovery: enRecovery,
    activityLogs: enActivityLogsPage,
    settings: enSettingsPage,
    forms: enForms
  },
  es: {
    common: es,
    menu: esMenu,
    home: esHomePage,
    seats: esSeatsPage,
    recovery: esRecovery,
    activityLogs: esActivityLogsPage,
    settings: esSettingsPage,
    forms: esForms
  },
  ja: {
    common: ja,
    menu: jaMenu,
    home: jaHomePage,
    seats: jaSeatsPage,
    recovery: jaRecovery,
    activityLogs: jaActivityLogsPage,
    settings: jaSettingsPage,
    forms: jaForms
  },
}

const savedLocale = localStorage.getItem('lang')
const supportedLocales = ['en', 'es', 'ja']

const i18n = new VueI18n({
  locale: supportedLocales.includes(savedLocale) ? savedLocale : 'en',
  fallbackLocale: 'en',
  messages,
})

export default i18n
